import { Button, Flex, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure } from "@chakra-ui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import axios from "axios";
import React from "react";
import { AiFillEye } from "react-icons/ai";
import { Store } from 'react-notifications-component';

const ViewPropositionModal = (props) => {
    const { address } = useGetAccountInfo();
    const { isOpen, onOpen, onClose } = useDisclosure();

    function acceptProposition() {
        axios.put(`${process.env.REACT_APP_API_URL}/proposals/${props.data._id}`, { status : "IN_PROGRESS" }, {
            headers: {
                signature: localStorage.getItem("signature"),
                "user-wallet-address": address
            }
        }).then(() => {
                Store.addNotification({
                    title: "Good Job Astronaut 🚀",
                    message: "You successfully accepted the proposition",
                    type: "success",
                    insert: "top",
                    container: "bottom-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        pauseOnHover: true
                    }
                });
            })
            .catch(() => {
                Store.addNotification({
                    title: "Error Astronaut",
                    message: "Try again later ...",
                    type: "danger",
                    insert: "top",
                    container: "bottom-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        pauseOnHover: true
                    }
                });
            }).finally(() => {
                onClose();
                props.setisMutating(true);
            });
    }
    function declineProposition() {
        axios.put(`${process.env.REACT_APP_API_URL}/proposals/${props.data._id}`, { status : "DECLINED" }, {
            headers: {
                signature: localStorage.getItem("signature"),
                "user-wallet-address": address
            }
        }).then(() => {
                Store.addNotification({
                    title: "Good Job Astronaut 🚀",
                    message: "You successfully deleted the proposition",
                    type: "success",
                    insert: "top",
                    container: "bottom-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        pauseOnHover: true
                    }
                });
            })
            .catch(() => {
                Store.addNotification({
                    title: "Error Astronaut",
                    message: "Try again later ...",
                    type: "danger",
                    insert: "top",
                    container: "bottom-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                        pauseOnHover: true
                    }
                });
            }).finally(() => {
                onClose();
                props.setisMutating(true);
            });
    }

    return (
        <>
            <Icon
                onClick={onOpen}
                w='24px'
                h='24px'
                me='5px'
                color={'white'}
                as={AiFillEye}
                cursor='pointer'
            />
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent bg={'navy.800'}>
                    <ModalHeader>{props.data.title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody mb={15}>
                        {/* <FormDao data={props.data} edit={false} /> */}
                        <Flex mb={25} fontFamily={'body'}>
                        {props.data.description}
                        </Flex>
                        <Flex align='center' justifyContent={'space-evenly'}>
                            <Button onClick={acceptProposition} className="btn-secondary" width={'100px'}>Accept</Button>
                            <Button onClick={declineProposition} className="btn-secondary" width={'100px'}>Decline</Button>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default ViewPropositionModal;